var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container fluid mt-3"},[_c('div',{staticClass:"grid-x grid-margin-y"},[_vm._m(0),_c('div',{staticClass:"cell"},[_c('ShipmentList')],1)]),_c('ShipmentActionButtons')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell"},[_c('h1',{staticClass:"display-2 grey--text"},[_vm._v(" Shipments ")])])
}]

export { render, staticRenderFns }